<template>
  <div class="product-category">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>商品分类管理</span>
          <el-button type="primary" @click="handleAdd">添加分类</el-button>
        </div>
      </template>
      
      <el-table :data="categoryList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="分类名称" />
        <el-table-column prop="sort_order" label="排序" />
        <el-table-column prop="created_at" label="创建时间" />
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 编辑/添加对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="分类名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_order" :min="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'ProductCategory',
  setup() {
    const categoryList = ref([])
    const dialogVisible = ref(false)
    const dialogTitle = ref('')
    const form = ref({})
    
    const fetchCategories = async () => {
      try {
        const res = await request.get('/api/admin/shop-categories')
        categoryList.value = res.data || []
      } catch (error) {
        ElMessage.error('获取分类失败')
      }
    }
    
    const handleAdd = () => {
      form.value = { sort_order: 0 }
      dialogTitle.value = '添加分类'
      dialogVisible.value = true
    }
    
    const handleEdit = (row) => {
      form.value = { ...row }
      dialogTitle.value = '编辑分类'
      dialogVisible.value = true
    }
    
    const handleSave = async () => {
      try {
        if (form.value.id) {
          await request.put(`/api/admin/shop-categories/${form.value.id}`, form.value)
        } else {
          await request.post('/api/admin/shop-categories', form.value)
        }
        ElMessage.success('保存成功')
        dialogVisible.value = false
        fetchCategories()
      } catch (error) {
        ElMessage.error('保存失败')
      }
    }
    
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm('确认删除该分类？', '提示', { type: 'warning' })
        await request.delete(`/api/admin/shop-categories/${row.id}`)
        ElMessage.success('删除成功')
        fetchCategories()
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败')
        }
      }
    }
    
    onMounted(() => {
      fetchCategories()
    })
    
    return {
      categoryList,
      dialogVisible,
      dialogTitle,
      form,
      handleAdd,
      handleEdit,
      handleSave,
      handleDelete
    }
  }
}
</script>

<style scoped>
.product-category {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.card-header span {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}
</style>
